// CRM motion primitives — Framer Motion spring presets. The ONLY net-new design tokens CRM adds.
// Rule: every interactive element uses ONE of these; no ad-hoc spring/tween configs.

export const spring = {
  instant: { type: "spring", stiffness: 700, damping: 40, mass: 0.6 },
  quick:   { type: "spring", stiffness: 500, damping: 38, mass: 0.8 },
  smooth:  { type: "spring", stiffness: 320, damping: 32, mass: 1.0 },
  bouncy:  { type: "spring", stiffness: 380, damping: 22, mass: 1.0 },
  drag:    { type: "spring", stiffness: 600, damping: 45, mass: 0.7 },
};

export const easing = {
  standard: [0.4, 0.0, 0.2, 1],
  accelerate: [0.4, 0.0, 1.0, 1],
  decelerate: [0.0, 0.0, 0.2, 1],
};

export const duration = {
  instant: 0.08,
  quick: 0.16,
  smooth: 0.24,
  slow: 0.4,
};

export const fade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: duration.quick, ease: easing.standard },
};

export const slideRight = {
  initial: { x: 32, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: 32, opacity: 0 },
  transition: spring.smooth,
};

export const drawerFromRight = {
  initial: { x: "100%" },
  animate: { x: 0 },
  exit: { x: "100%" },
  transition: spring.smooth,
};

export const scaleIn = {
  initial: { scale: 0.96, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.96, opacity: 0 },
  transition: spring.quick,
};

export const tapScale = { whileTap: { scale: 0.97 }, transition: spring.instant };
export const hoverLift = { whileHover: { y: -1 }, transition: spring.quick };
